import { ModuleConstants } from '@hrms/common/constant/modules';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ScreenNames } from '@hrms/common/routes/screens';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { generateImage } from '@hrms/common/utils/generateImage';

const itApprovalsBaseRoute = '/it-approvals';

const getITApprovalsModuleRoutes: ModuleRoutesComponentInterface = () => [
  {
    id: ModuleConstants.IT_APPROVALS,
    route: itApprovalsBaseRoute,
    title: ScreenNames.IT_APPROVALS,
    icon: generateImage({
      noScale: true,
      name: 'approval',
      alt: 'it-approvals',
      className: 'w-4 h-4',
    }),
    component: null,
    children: [
      {
        id: ModuleConstants.IT_APPROVALS_SEPARATION,
        route: `${itApprovalsBaseRoute}/separation`,
        title: ScreenNames.IT_APPROVALS_SEPARATION,
        component: ComponentsMap.APPROVAL_IT_REVIEW_LIST,
      },
      {
        id: ModuleConstants.IT_APPROVALS_EMPLOYEE_ASSET,
        route: `${itApprovalsBaseRoute}/employee-asset`,
        title: ScreenNames.IT_APPROVALS_EMPLOYEE_ASSET,
        component: ComponentsMap.IT_APPROVALS_EMPLOYEE_ASSET,
      },
    ],
  },
];

export default getITApprovalsModuleRoutes;
